module.exports = {
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
};
